export type History<T> = {
  push(entry: T): void;
  undo(): T | undefined;
  redo(): T | undefined;
  canUndo(): boolean;
  canRedo(): boolean;
};

export function createHistory<T>(cap: number): History<T> {
  const past: T[] = [];
  const future: T[] = [];
  return {
    push(entry) {
      past.push(entry);
      if (past.length > cap) past.shift();
      future.length = 0;
    },
    undo() {
      const entry = past.pop();
      if (entry !== undefined) future.push(entry);
      return entry;
    },
    redo() {
      const entry = future.pop();
      if (entry !== undefined) past.push(entry);
      return entry;
    },
    canUndo: () => past.length > 0,
    canRedo: () => future.length > 0,
  };
}
